import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Client, ClientService } from '@morningstar/shared/services/client';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'mstar-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.css']
})
export class ClientsComponent implements OnInit {

  @Input() label = 'Client';
  processing = new BehaviorSubject<boolean>(false);
  processing$ = this.processing.asObservable();
  clients: Client[];
  @Input() parent: FormGroup;
  @Input() showNone = false;
  @Input() value = '';
  @Input() model: any;
  @Input() location = '';
  @Input() allLocations = false;
  @Output() modelChange: EventEmitter<Client> = new EventEmitter<Client>();
  @Input() setDefaultOption = true;
  @Input() includeAll = false;
  @Input() includeMasters = true;
  @Input() includeParticipants = true;
  getAllUsers = false;
  @Output() clientChange = new EventEmitter<Client>();
  @Input() disabled = false;

  constructor(private clientService: ClientService) { }

  ngOnInit() {
    if (this.isReactive()) {
      if (this.location) {
        this.getClientsByLocation(this.location);
      }

      this.parent.get('location').valueChanges.subscribe(location => {
        if (location) {
          this.getClientsByLocation(location);
        }
      });
    } else {
      this.getClientsByLocation(this.location);
    }
  }

  getClient(tenantId: string): Client {
    return this.clients.find(c => c.id === tenantId);
  }

  getClientsByLocation(location: string) {

    if (this.allLocations) {
      location = '';
    }

    this.processing.next(true);
    this.clientService.getClientsByLocation(location, false, false, this.includeMasters, this.includeParticipants)
                        .subscribe(clients => {
                          if (this.includeAll) {
                            const allClient = new Client();
                            allClient.id = 'ALL';
                            allClient.name = 'All';

                            clients.splice(0, 0, allClient);
                          }

                          this.clients = clients;

                          if (!this.isReactive() && clients.length > 0 && this.setDefaultOption) {
                            if (this.value !== '') {
                              this.modelChange.emit(this.clients.find(c => c.id.toString() === this.value));
                            } else {
                              this.modelChange.emit(this.clients[0]);
                            }
                          } else if (this.isReactive() && this.value) {
                            this.parent.patchValue({
                              tenantId: this.value
                            });

                            this.clientChange.emit(this.getClient(this.value));
                          } else if (this.isReactive() && this.setDefaultOption) {
                            this.parent.patchValue({
                              tenantId: this.clients[0].id
                            });
                          }

                          this.clientChange.emit(this.getClient(this.clients[0].id));

                          this.processing.next(false);
                        }, error => {
                          this.processing.next(false);
                        });
  }

  isReactive(): boolean {
    return typeof this.parent !== 'undefined';
  }

  updateModel() {
    const client = this.clients.filter(u => u.id === this.model);
    this.modelChange.emit(client[0]);
  }

  updateReactiveModel() {
    const id = this.parent.get('tenantId').value;
    if (!id) {
      this.clientChange.emit(null);
    } else {
      const client = this.clients.find(c => c.id === id);
      this.clientChange.emit(client);
    }
  }
}
